import { render, staticRenderFns } from "./PassoSobreReembolso.vue?vue&type=template&id=ad080af6"
import script from "./PassoSobreReembolso.vue?vue&type=script&lang=js"
export * from "./PassoSobreReembolso.vue?vue&type=script&lang=js"
import style0 from "./PassoSobreReembolso.vue?vue&type=style&index=0&id=ad080af6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VFileInput,VForm,VIcon,VTextarea})
